import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/home/Home.vue'
import Blogs from '@/views/blog/Blogs.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  // 切换页面滚动到页面顶部
  scrollBehavior(to, from, savedPosition) {
      return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', name: 'Home', component: Home, meta: { title: null } },
    { path: '/blogs', name: 'Blogs', component: Blogs, meta: { title: '博客' } }
  ]
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

router.afterEach(to => {
  window.scrollTo(0, 0)
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js